import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    AppleIcon,
    AndroidIcon,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import {
    generateAppleStoreUrl,
    generateGooglePlayStoreUrl,
} from '../../../urls';

import styles from './IconBar.scss';

function IconBar(props) {
    const {
        t,
        appPage,
        campaign,
    } = props;

    const appleStoreUrl = generateAppleStoreUrl(campaign);
    const googlePlayStoreUrl = generateGooglePlayStoreUrl(campaign);

    return (
        <>
            <A
                aria-label={t('apple-phone-icon')}
                className={classNames(
                    styles.iconBox,
                    { [styles.whiteBox]: !appPage },
                )}
                href={appleStoreUrl}
                native
            >
                <AppleIcon
                    alt="wanderu"
                    className={classNames(
                        styles.appIcon,
                        {
                            [styles.appPageIcon]: appPage,
                            [styles.largeIcon]: appPage,
                        },
                    )}
                />
                <div
                    className={classNames(
                        styles.iconText,
                        { [styles.hidden]: appPage },
                    )}
                >
                    {t('iphone')}
                </div>
            </A>
            <A
                aria-label={t('android-phone-icon')}
                className={classNames(
                    styles.iconBox,
                    { [styles.whiteBox]: !appPage },
                )}
                href={googlePlayStoreUrl}
                native
            >
                <AndroidIcon
                    alt="wanderu"
                    className={classNames(
                        styles.appIcon,
                        styles.androidIcon,
                        {
                            [styles.largeIcon]: appPage,
                        },
                    )}
                />
                <div
                    className={classNames(
                        styles.iconText,
                        styles.androidText,
                        { [styles.hidden]: appPage },
                    )}
                >
                    {t('android')}
                </div>
            </A>
        </>
    );
}

IconBar.propTypes = {
    appPage: PropTypes.bool,
};
IconBar.defaultProps = {
    appPage: false,
};

export { IconBar };
export default localize(IconBar, ['t'], 'baseApp');
